import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Container, Table, Badge as BsBadge, Button, Tooltip, OverlayTrigger, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useQueryClient } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { HOSO_NGHIENCUUSINH_API, CONGNHANTIENSI_API } from '@app/utils/apiUrl';
import { Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '@app/utils/helper';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { userManager } from '@app/utils/oidc';
import { objectShowNumber, objectTrangThaiHoSoNCS, trangThaiHoSoNCSValue } from '@app/utils/define';
import ThongTinNghienCuuSinhModal from './ThongTinNghienCuuSinhModal';
import CongNhanTienSiModal from '../quanLyHoSoNCS/CongNhanTienSiModal';
const HoSoNghienCuuSinh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(1000);
    const [search, setSearch] = useState('');
    const [accountId, setAccountId] = useState('');

    const [showDetail, setShowDetail] = useState(false);
    const [showCongNhanTienSi, setShowCongNhanTienSi] = useState(false);
    const [selectedHoSoId, setSelectedHoSoId] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const queryClient = useQueryClient();

    useEffect(() => {
        const fetchInfo = async () => {
            const user = await userManager.getUser();
            const accId = user?.profile?.sub || null;
            if (accId) setAccountId(accId);
        };
        fetchInfo();
    }, []);

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const replaceHistory = (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.HOSO_NGHIENCUUSINH_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const { isLoading, data, refetch } = useQuery(
        ['myHoSoNCS', accountId, valueSearch, page, pageSize],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                AccountId: accountId
            };
            replaceHistory(page, pageSize, valueSearch);
            return Get(HOSO_NGHIENCUUSINH_API.GET_PAGING, null, model);
        },
        {
            enabled: !!accountId,
            keepPreviousData: true
        }
    );

    const { data: congNhanTienSiData } = useQuery(
        ['congNhanTienSiUser', selectedRow?.id || selectedRow?.Id],
        () => Get(`${CONGNHANTIENSI_API.GET_BY_HOSO_ID}/${selectedRow?.id || selectedRow?.Id}`),
        {
            enabled: !!(selectedRow?.id || selectedRow?.Id)
        }
    );

    const isDaGuiCongNhanTienSi = () => {
        if (!congNhanTienSiData) return false;
        let item = null;
        if (Array.isArray(congNhanTienSiData)) {
            item = congNhanTienSiData[0];
        } else if (congNhanTienSiData.data && Array.isArray(congNhanTienSiData.data)) {
            item = congNhanTienSiData.data[0];
        } else if (congNhanTienSiData.data?.$values) {
            item = congNhanTienSiData.data.$values[0];
        } else if (congNhanTienSiData.data) {
            item = congNhanTienSiData.data;
        } else {
            item = congNhanTienSiData;
        }
        
        if (!item || !item.id) return false;
        
        const status = item.trangThaiGuiKetQua ?? item.TrangThaiGuiKetQua;
        return status === 1 || status === 'DaGui';
    };

    useEffect(() => {
        if (accountId) {
            refetch();
        }
    }, [pageSize, page, accountId, valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    useEffect(() => {
        if (items && items.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = items.find(item => (item.id || item.Id) === (prev.id || prev.Id));
                    return fresh || items[0];
                }
                return items[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [items]);

    const handleViewDetail = (app) => {
        setSelectedHoSoId(app.id || app.Id);
        setShowDetail(true);
    };

    const handleYeuCauThayDoi = (app) => {
        const id = app.id || app.Id;
        history.push(URI_INTERNAL.YEUCAU_THAYDOI_NCS_PATH.replace(':id', id));
    };

    const handleDoubleClick = (app) => {
        const id = app.id || app.Id;
        history.push(URI_INTERNAL.GIAIDOAN_DAOTAO_NCS_PATH.replace(':id', id));
    };

    const renderTooltip = (props, text) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );

    return (
        <div className="container-fluid">
            <Card className="card-sticky-layout card-sticky-layout-lg">
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5 className="font-weight-bold m-0">Hồ sơ Nghiên cứu sinh</h5>
                    </div>
                </Card.Header>
                <Card.Body className="d-flex flex-column p-0">
                    <Card className="card-sticky-layout border-0 shadow-none flex-grow-1">
                        <Card.Body className="d-flex flex-column">
                            <div className="table-responsive flex-grow-1">
                                <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th className="text-center" style={{ width: '50px' }}>STT</th>
                                    <th>Mã NCS</th>
                                    <th>Ngành</th>
                                    <th>Chuyên ngành</th>
                                    <th>Tên đề tài</th>
                                    <th>Đợt tuyển sinh</th>
                                    {/* <th>Thời hạn</th> */}
                                    <th>Từ ngày</th>
                                    <th>Đến ngày</th>
                                    <th className="text-center">Trạng thái</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="10" className="text-center">Đang tải dữ liệu...</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan="9" className="text-center">Không có dữ liệu</td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => {
                                        const hsTS = item.hoSoTuyenSinhInfo || {};
                                        
                                        let thoiHanStr = '';
                                        if (item.thoiHanDaoTao === 0 || String(item.thoiHanDaoTao) === '0' || (typeof item.thoiHanDaoTao === 'string' && item.thoiHanDaoTao.toLowerCase() === 'banam')) {
                                            thoiHanStr = '3 năm';
                                        } else if (item.thoiHanDaoTao === 1 || String(item.thoiHanDaoTao) === '1' || (typeof item.thoiHanDaoTao === 'string' && item.thoiHanDaoTao.toLowerCase() === 'bonnam')) {
                                            thoiHanStr = '4 năm';
                                        }

                                        const trangThaiVal = item.trangThai ?? item.TrangThai ?? trangThaiHoSoNCSValue.choDaoTao;
                                        const trangThaiObj = objectTrangThaiHoSoNCS.find(x => x.value === trangThaiVal);
                                        const trangThaiLabel = trangThaiObj ? trangThaiObj.label : 'Chờ đào tạo';
                                        
                                        let variant = 'warning';
                                        if (trangThaiVal === trangThaiHoSoNCSValue.choDaoTao) variant = 'warning';
                                        else if (trangThaiVal === trangThaiHoSoNCSValue.dangDaoTao || trangThaiVal === trangThaiHoSoNCSValue.congNhanTienSi) variant = 'success';
                                        else if (trangThaiVal === trangThaiHoSoNCSValue.tamDungDaoTao) variant = 'info';
                                        else if (trangThaiVal === trangThaiHoSoNCSValue.dangGiaHan || trangThaiVal === trangThaiHoSoNCSValue.quaHan) variant = 'danger';
                                        else if (trangThaiVal === trangThaiHoSoNCSValue.boDaoTao) variant = 'primary';

                                        return (
                                            <tr 
                                                key={item.id} 
                                                onDoubleClick={() => handleDoubleClick(item)} 
                                                onClick={() => setSelectedRow(item)}
                                                className={selectedRow && ((selectedRow.id || selectedRow.Id) === (item.id || item.Id)) ? 'table-primary' : ''}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                            >
                                                <td className="text-center">{(page - 1) * pageSize + index + 1}</td>
                                                <td>{item.maNCS || hsTS.soHoSo}</td>
                                                <td>{item.tenNganh}</td>
                                                <td>{item.tenChuyenNganh || 'Không có'}</td>
                                                <td>{item.tenDeTai}</td>
                                                <td>{item.tenDotTuyenSinh}</td>
                                                {/* <td>{thoiHanStr}</td> */}
                                                <td>{item.tuNgay ? moment(item.tuNgay).format('DD/MM/YYYY') : ''}</td>
                                                <td>
                                                    {item.denNgay ? moment(item.denNgay).format('DD/MM/YYYY') : ''}
                                                    {item.soThangGiaHan ? (
                                                        <div style={{ fontSize: '0.85em', color: '#ff9800', marginTop: '4px', whiteSpace: 'nowrap' }}>
                                                            <i className="fas fa-clock mr-1"></i>Gia hạn {item.soThangGiaHan} tháng
                                                        </div>
                                                    ) : null}
                                                </td>
                                                <td className="text-center">
                                                    <BsBadge variant={variant}>{trangThaiLabel}</BsBadge>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                                </Table>
                            </div>

                    {/* <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            {totalRecords > 0 && (
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    innerClass="pagination pagination-sm no-margin"
                                    activePage={page}
                                    itemsCountPerPage={pageSize}
                                    totalItemsCount={totalRecords}
                                    pageRangeDisplayed={5}
                                    onChange={changePage}
                                />
                            )}
                        </div>
                    </div> */}
                        </Card.Body>
                        {!isLoading && (
                            <Card.Footer className="bg-white card-footer-sticky">
                                <div className="d-flex justify-content-end pr-4">
                                    <Button 
                                        variant="info" 
                                        size="sm" 
                                        className="mr-2 d-inline-flex align-items-center justify-content-center" 
                                        onClick={() => handleViewDetail(selectedRow)} 
                                        disabled={!selectedRow} 
                                        style={{ whiteSpace: 'nowrap', fontSize: '13.5px', padding: '3px 8px' }}
                                    >
                                        <i className="fas fa-eye mr-1"></i> Xem chi tiết
                                    </Button>
                                    <Button 
                                        variant="warning" 
                                        size="sm" 
                                        className="mr-2 d-inline-flex align-items-center justify-content-center" 
                                        onClick={() => handleYeuCauThayDoi(selectedRow)} 
                                        disabled={
                                            !selectedRow || 
                                            [trangThaiHoSoNCSValue.tamDungDaoTao, trangThaiHoSoNCSValue.boDaoTao, trangThaiHoSoNCSValue.hetHan, trangThaiHoSoNCSValue.congNhanTienSi].includes(selectedRow.trangThai ?? selectedRow.TrangThai)
                                        } 
                                        style={{ whiteSpace: 'nowrap', fontSize: '13.5px', padding: '3px 8px' }}
                                    >
                                        <i className="fas fa-exchange-alt mr-1"></i> Yêu cầu thay đổi
                                    </Button>
                                    {isDaGuiCongNhanTienSi() && (
                                        <Button 
                                            variant="success" 
                                            size="sm" 
                                            className="d-inline-flex align-items-center justify-content-center" 
                                            onClick={() => setShowCongNhanTienSi(true)} 
                                            style={{ whiteSpace: 'nowrap', fontSize: '13.5px', padding: '3px 8px' }}
                                        >
                                            <i className="fas fa-graduation-cap mr-1"></i> Công nhận tiến sĩ
                                        </Button>
                                    )}
                                </div>
                            </Card.Footer>
                        )}
                    </Card>
                </Card.Body>
            </Card>

            {showDetail && selectedHoSoId && (
                <ThongTinNghienCuuSinhModal
                    show={showDetail}
                    handleClose={() => {
                        setShowDetail(false);
                        setSelectedHoSoId(null);
                    }}
                    hoSoId={selectedHoSoId}
                />
            )}

            {showCongNhanTienSi && selectedRow && (
                <CongNhanTienSiModal
                    dataEdit={selectedRow}
                    isUserView={true}
                    isView={true}
                    setViewMode={(mode) => {
                        if (mode === 'list') {
                            setShowCongNhanTienSi(false);
                            queryClient.invalidateQueries(['congNhanTienSiUser']);
                        }
                    }}
                />
            )}
        </div>
    );
};

export default HoSoNghienCuuSinh;
